import { useState, useEffect } from "react";

const API = `${window.location.origin}/api`;

export default function RunningHeader() {
  const [text, setText] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const res = await fetch(`${API}/settings/running-header`);
        const data = await res.json();
        setText(data.text || "");
        setEnabled(data.enabled || false);
      } catch {}
    };
    fetchHeader();
    const interval = setInterval(fetchHeader, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!enabled || !text) return null;

  return (
    <div
      data-testid="running-header"
      className="w-full overflow-hidden border-y-2 border-yellow-500 bg-yellow-50"
      style={{ zIndex: 9999, position: "relative" }}
    >
      <div className="marquee-track py-1.5">
        <span className="marquee-text text-sm font-bold text-red-700 tracking-wide uppercase whitespace-nowrap px-8">
          {text}
          <span className="mx-16 text-yellow-500">&#9733;</span>
          {text}
          <span className="mx-16 text-yellow-500">&#9733;</span>
          {text}
          <span className="mx-16 text-yellow-500">&#9733;</span>
        </span>
      </div>

      <style>{`
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee-scroll 25s linear infinite;
        }
        .marquee-text {
          display: inline-block;
        }
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
    </div>
  );
}
